import { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";

// ------------------ CONSULTAS A LA API--------------------------
import { getIngresos } from "../../../../API/Finanzas/NotasProveedores/NotasProveedoresRequest";

const OverlayIngresos = ({
    selectedPcs,
    setSelectedPCs,
    IdTipoIngreso,
    IdVendor,
    habilitar,
    agregarNuevaFila,
}) => {
    const lo = useRef(null);
    const toast = useRef();

    const { userAuth } = useContext(AuthContext);

    const [dataIngresos, serDataIngresos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(false);

    const openOver = (e) => {
        if (IdTipoIngreso && IdVendor) {
            setShouldFetch(true);
            lo.current.toggle(e);
        } else {
            toastShow( toast, "warn", "Advertencia", "Seleccione un proveedor y un Inventario");
        }
    };

    const fetchData = async () => {
        if (IdTipoIngreso && IdVendor) {
            setLoading(true);
            const dataTempo = await getIngresos(IdTipoIngreso, IdVendor);
            serDataIngresos(dataTempo);
            setLoading(false);
        }
    };

    const AsignarInformacion = () => {
        agregarNuevaFila(selectedPcs);
        lo.current.hide();
        setSelectedPCs([]);
    };

    const columns = [
        {
            field: "IdIngresoDetalle",
            header: "ID",
            headerEn: "ID",
            className: "XXsmall",
            frozen: true,
            hidden: userAuth.IdRol === 1,
        },
        {
            field: "CodigoProducto",
            header: "Código",
            headerEn: "Code",
            className: "Xsmall",
        },
        {
            field: "NombreProducto",
            header: "Producto",
            className: "medium",
            flex: 1,
            minWidth: 200,
        },
        {
            field: "PurchaseOrder",
            header: "OC",
            headerEn: "PO",
            className: "Xsmall",
            filter: true,
        },
        {
            field: "NumeroIngreso",
            header: "Ingreso",
            className: "small",
            Format: "Modal",
        },
        {
            field: "Factura",
            header: "Factura",
            headerEn: "Invoice",
            className: "large",
            filter: true,
        },
        {
            field: "BalanceDevolucion",
            header: "Balance Devolucion",
            Format: "Currency",
            className: "Xsmall",
            filter: true,
        },
        {
            field: "Ingreso",
            header: "Ingresó",
            headerEn: "Entered",
            Format: "Currency",
            className: "Xsmall",
            filter: true,
        },
        {
            field: "UnitName",
            header: "Unidad",
            headerEn: "Unit",
            className: "Xsmall",
            filter: true,
        },
        {
            field: "PrecioL",
            header: "Precio L",
            headerEn: "Price L",
            Format: "Currency",
            className: "Xsmall",
            frozen: true,
            alignFrozen: "right",
        },
        {
            field: "PrecioD",
            header: "Precio $",
            headerEn: "Price $",
            Format: "Currency",
            className: "Xsmall",
            frozen: true,
            alignFrozen: "right",
        },
        {
            field: "MontoL",
            header: "Monto L",
            headerEn: "Amount L",
            Format: "Currency",
            className: "Xsmall",
            frozen: true,
            alignFrozen: "right",
        },
        {
            field: "MontoD",
            header: "Monto $",
            headerEn: "Amount $",
            Format: "Currency",
            className: "Xsmall",
            frozen: true,
            alignFrozen: "right",
        },
    ];

    useEffect(() => {
        if (shouldFetch) {
            fetchData();
            setShouldFetch(false);
        }
    }, [shouldFetch]);

    useEffect(() => {
        if (IdVendor || IdTipoIngreso) {
            fetchData();
        }
    }, [IdVendor, IdTipoIngreso]);

    const table = {
        Data: dataIngresos,
        selected: selectedPcs,
        setSelected: setSelectedPCs,
        Columns: columns,
        loading: loading,
    };

    return (
        <div>
            <Toast ref={toast} />
            <div className="p-inputgroup mx-2">
                <Button
                    label="Agregar"
                    onClick={() => AsignarInformacion()}
                    disabled={!selectedPcs || selectedPcs?.length === 0}
                />
                <Button
                    icon="pi pi-angle-down"
                    type="button"
                    onClick={(e) => openOver(e)}
                    disabled={!habilitar || !IdVendor || !IdTipoIngreso}
                />
            </div>
            <OverlayPanel ref={lo} showCloseIcon dismissable={false}>
                <Loader querySelector="FacturasPagoCliente" />
                <div style={{ height: "55vh", width: "60vw" }} id="FacturasPagoCliente">
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>
    );
};

export default OverlayIngresos;
